<template>
  <div class="create-project-block container my-3">
    <h5 class="create-project-header">
      {{
        $resourceString[
          "myProject.Project.EditPage.Item.ColorPreviewModal.Title"
        ]
      }}
    </h5>
    <button
      type="button"
      class="wf-modal-button-close btn button-full"
      @click="
        () => {
          hideModal('colors-preview');
        }
      "
    >
      <span
        class="png-icon png-icon-icons-symbols--k-txtclose"
        aria-label="Close modal"
      />
    </button>

    <div>
      <div class="" v-if="getFilteredRecord && getFilteredRecord.length > 0">
        <div class="modal-body">
          <div class="color-preview-slide">
            <VueSlickCarousel
              v-if="selectedColor && selectedColor.colorNumber"
              v-bind="settings"
            >
              <template #nextArrow>
                <button type="button" class="custom-arrow-next">
                  <span
                    class="png-icon png-icon-icons-glyph--ko-chevron-right"
                  ></span>
                </button>
              </template>
              <template #prevArrow>
                <button type="button" class="custom-arrow-prev">
                  <span
                    class="png-icon png-icon-icons-glyph--ko-chevron-left"
                  ></span>
                </button>
              </template>
              <!-- Render the selected color first -->
              <div v-if="selectedColor" :key="selectedColor.colorNumber">
                <img
                  class="preview-img-fluid"
                  :src="
                    selectedColor.imageLink
                      ? selectedColor.imageLink
                      : selectedColor.imagePath
                  "
                  alt=""
                />
                <!-- Description component -->
                <my-project-color-preview-description
                  @addItemToCart="addItemToCart($event)"
                  :color="selectedColor"
                ></my-project-color-preview-description>
              </div>

              <!-- Render the rest of the colors -->
              <div
                v-for="(color, index) in getFilteredRecord"
                :key="index"
                v-if="
                  selectedColor &&
                    color.colorNumber !== selectedColor.colorNumber
                "
              >
                <img
                  class="preview-img-fluid"
                  :src="color.imageLink ? color.imageLink : color.imagePath"
                  alt=""
                />
                <!-- description -->
                <my-project-color-preview-description
                  @addItemToCart="addItemToCart($event)"
                  :color="color"
                ></my-project-color-preview-description>
              </div>
            </VueSlickCarousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import MyProjectColorPreviewDescription from "./my-project-color-preview-description.vue";
export default {
  props: ["productData"],
  components: {
    VueSlickCarousel,
    MyProjectColorPreviewDescription
  },
  data() {
    return {
      settings: {
        centerMode: false,
        centerPadding: "8px",
        speed: 900,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        adaptiveHeight: true
      }
    };
  },
  computed: {
    ...mapGetters({
      getSelectedProduct: "contentWizard/getSelectedProduct"
    }),

    getFilteredRecord() {
      const selectedColorNumbers = this.productData.colors.productContentItem.productStyleImages.map(
        color => color.colorNumber
      );
      return (
        this.getSelectedProduct?.colors.filter(color =>
          selectedColorNumbers.includes(color.colorNumber)
        ) || []
      );
    },

    selectedColor() {
      const colorNumber = this.productData.item.colorNumber;
      return this.getFilteredRecord?.find(
        color => color.colorNumber === colorNumber
      );
    }
  },
  methods: {
    ...mapActions({
      addToCart: "newBasketPage/addToCart"
    }),

    hideModal(name) {
      this.$modal.hide(name + "-modal");
    },
    async addItemToCart(colorNumber) {
      if (this.selectedColor) {
        let data = {
          sellingStyleNumber: this.getSelectedProduct.styleNumber,
          colorNumber: colorNumber,
          quantity: 1.0
        };
        await this.addToCart(data);
      } else {
        // Handle the case when there is no selected color
        // console.error("No selected color");
      }
    }
  }
};
</script>
